import React, { Component } from 'react';
// import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Switch, Route, Link, withRouter, matchPath } from 'react-router-dom';
import { Provider, connect } from "react-redux";
// import store from "./store";
import { logIn, logOut, verify, updateDashboardTable, updateDashboardSearch } from "./reducers/index";

import { Layout, Menu } from 'antd';

const { Header, Content, Footer } = Layout;

import ProtectedRoute from './components/_global/ProtectedRoute';

import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Registration from './pages/Registration';
import Schedule from './pages/Schedule';
import Sessions from './pages/Sessions';
import Settings from './pages/Settings';
import Courses from './pages/Courses';

require('dotenv').config();


function Navigation(props) {
    let href = window.location.href.split('/');
    href = href[3];
    if (props.isLoggedIn && href == '') href = 'dashboard';
    if (props.isLoggedIn) {
        return (
            <Menu theme="light" mode="horizontal" defaultSelectedKeys={ ['/' + href] } selectedKeys={ ['/' + href] }
                  style={ {
                      lineHeight: '62px'
                  } }>
                <Menu.Item key="/dashboard">
                    <Link to="/dashboard">Dashboard</Link>
                </Menu.Item>
                <Menu.Item key="/courses">
                    <Link to="/courses">Courses</Link>
                </Menu.Item>
                <Menu.Item key="/sessions">
                    <Link to="/sessions">Sessions</Link>
                </Menu.Item>
                <Menu.Item key="/registration">
                    <Link to="/registration">Registration</Link>
                </Menu.Item>
                <Menu.Item key="/settings">
                    <Link to="/settings">Settings</Link>
                </Menu.Item>
                <Menu.Item key="6">
                    <span onClick={ props.logOut }>Log Out</span>
                </Menu.Item>
            </Menu>
        );
    } else {
        return (
            <Menu theme="light" mode="horizontal" defaultSelectedKeys={ ['/' + href] } selectedKeys={ ['/' + href] }
                  style={ {
                      lineHeight: '62px'
                  } }>
                <Menu.Item key="/registration">
                    <Link to="/registration">Registration</Link>
                </Menu.Item>
                <Menu.Item key="/login">
                    <Link to="/login">Log In</Link>
                </Menu.Item>
            </Menu>
        );
    }
}

function Logo(props) {
    if (props.isLoggedIn) {
        return (
            <Link to="/dashboard" id="nav-logo">
                <img src="/images/favicon.png"/>
                <span>VCH REGIONAL <br/>ORIENTATION</span>
            </Link>
        );
    } else {
        return (
            <Link to="/login" id="nav-logo">
                <img src="/images/favicon.png"/>
                <span>VCH REGIONAL <br/>ORIENTATION</span>
            </Link>
        );
    }
}

class Index extends Component {
    constructor(props) {
        super(props);
        this.logOut = this.logOut.bind(this);
    }

    componentDidMount() {
        this.props.verify();
    }

    logOut() {
        // clear the tokens from sessionStorage
        sessionStorage.setItem('access_token', undefined);
        sessionStorage.setItem('refresh_token', undefined);
        // clear the user/authentication from the redux store
        this.props.logOut();
    }

    // When component updates, check to see if url changes, if so, run onRouteChanges
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.onRouteChanged(this.props.location.pathname);
        }
    }

    // Reset saved dashboard pagination unless the user navigated to the submission details page
    // or is navigating back to the dashboard page
    onRouteChanged(path) {
        // Use react router matchPath to get both paths
        const isSubmissionDetailPage = matchPath(path, {
            path: "/schedule/:id",
            exact: true,
            strict: false
        });

        const isDashboardPage = matchPath(path, {
            path: "/dashboard",
            exact: true,
            strict: false
        });
        console.log(isDashboardPage);

        // If it matches neither page, set the dashbaord page back to 0
        if (!isSubmissionDetailPage && !isDashboardPage) {
            console.log("clear saved dashbaord pagination state");
            this.props.updateDashboardTable(0);
            this.props.updateDashboardSearch('');
        }
    }

    render() {
        return (<Layout>
            <Header style={ { background: '#fff', 'borderBottom': '1px solid #e8e8e8' } }>
                <Logo isLoggedIn={ this.props.isAuthenticated }/>
                <Navigation isLoggedIn={ this.props.isAuthenticated } logOut={ this.logOut }/>
            </Header>
            <Content>
                <Switch>
                    <Route path="/registration" component={ Registration }/>
                    <Route path="/login" component={ Login }/>
                    <ProtectedRoute path="/schedule/:submissionID" component={ Schedule }/>
                    <ProtectedRoute path="/sessions" component={ Sessions }/>
                    <ProtectedRoute path="/courses" component={ Courses }/>
                    <ProtectedRoute path="/settings" component={ Settings }/>
                    <ProtectedRoute path="/" component={ Dashboard }/>
                </Switch>
            </Content>
            <Footer>
                <h5>Questions?</h5>
                Contact <a href="mailto:VCHOrientation@VCH.ca?subject=[ROAR] - ">VCHOrientation@VCH.ca</a>
            </Footer>
        </Layout>);
    }
}

const mapStateToProps = (state) => {
    return state;
}

export default withRouter(connect(mapStateToProps, {
    verify,
    logOut,
    updateDashboardTable,
    updateDashboardSearch
})(Index));
